import { base as rubase } from "src/i18n/dictionaries/ru/base";

export const base: Record<keyof typeof rubase, string> = {
  "components.routes.pages.Error404.title": "Page not found",
  "components.routes.pages.Error404.description":
    "It may have been removed, or the address was entered incorrectly.",
  "components.routes.pages.Error404.backHome": "Back to home",
  "components.molecules.FavoriteItem.text": "Favorites",
  "components.molecules.BalanceInfo.balance": "Balance",
  "components.molecules.BalanceInfo.total": "Portfolio",
  "components.organisms.AuthHeader.addEvenet": "Create event",
  "components.organisms.AuthHeader.deposit": "Deposit",
  "components.organisms.AuthHeader.search": "Search the market",
  "components.templates.CabinetTemplate.all": "All",
  "components.molecules.StatisticsBlock.contract": "Trades",
  "components.molecules.StatisticsBlock.chart": "Trading volume",
  "components.molecules.StatisticsBlock.coin": "Profit / Loss",
  "components.atoms.FileInput.text": "Upload",
  "components.organisms.ProfileInfo.edit": "Edit",
  "components.organisms.ProfileInfo.deposit": "Deposit",
  "components.organisms.ProfileInfo.withdrow": "Withdrawal",
  "components.templates.CabinetTemplate.position": "Positions",
  "components.templates.CabinetTemplate.history": "History",
  "components.templates.CabinetTemplate.events": "My events",
  "components.templates.CabinetTemplate.referals": "Referral program",
  "components.routes.pages.Notifications.title": "Notifications",
  "components.routes.pages.Histories.title": "History",
  "components.routes.pages.Referals.title": "Referral program",
  "components.routes.pages.Events.title": "My events",
  "components.routes.pages.Positions.title": "Positions",
  "components.routes.pages.Positions.table.event": "Event",
  "components.routes.pages.Positions.table.value": "Outcome",
  "components.routes.pages.Positions.noData": "No more positions found",
  "components.routes.pages.Histories.noData": "No more history found",
  "components.routes.pages.Notifications.noData": "No notifications",
  "components.routes.pages.Histories.table.event": "Event",
  "components.routes.pages.Histories.table.input": "Your outcome",
  "components.routes.pages.Histories.table.output": "Result",
  "components.routes.pages.Histories.table.profit": "Your winnings",
  "components.routes.pages.Events.noData": "No more events found",
  "components.routes.pages.Events.table.status": "Status",
  "components.routes.pages.Events.table.event": "Event",
  "components.routes.pages.Events.table.status.moderation": "Under review",
  "components.routes.pages.Events.table.status.posted": "Published",
  "components.routes.pages.Referals.table.nikName": "Nickname",
  "components.routes.pages.Positions.table.bonus": "My bonus",
  "components.routes.pages.Positions.table.date": "Date",
  "components.routes.pages.Referals.noData": "No more bonuses found",
  "components.routes.pages.Referals.noDataBack": "List is empty",
  "components.routes.pages.EditProfile.title": "Profile",
  "components.forms.EditProfileForm.nikname": "Nickname",
  "components.forms.EditProfileForm.description": "Description",
  "components.forms.EditProfileForm.saveBtn": "Save",
  "components.forms.EditProfileForm.email": "Email",
  "components.forms.EditProfileForm.password": "Password",
  "components.forms.EditProfileForm.theme": "Theme",
  "components.forms.EditProfileForm.theme.light": "Light",
  "components.forms.EditProfileForm.theme.dark": "Dark",

  "components.forms.EditProfileForm.nikname.placeholder":
    "Enter your nickname",
  "components.forms.EditProfileForm.description.placeholder":
    "Tell us something about yourself...",
  "components.forms.EditProfileForm.email.placeholder": "Enter your email",
  "components.forms.EditProfileForm.password.placeholder":
    "Enter your password",
  "components.forms.EditProfileForm.returnBtn": "Back to profile",
  "components.organisms.ReferalInfo.promocode.placeholder":
    "Enter your promo code",
  "components.organisms.ReferalInfo.promocode": "Your promo code",
  "components.organisms.ReferalInfo.btn": "Share with friends",
  "components.organisms.ReferalInfo.title": "How it works",
  "components.organisms.ReferalInfo.text":
    "Here you will find your unique promo code. Share it with friends and earn bonuses for every one of them. The more people join — the more bonuses you get! Anyone who uses your promo code also receives a bonus on their first deposit.",
  "components.organisms.ReferalInfo.textInfo":
    "As soon as an invited user makes their first deposit, you instantly receive a bonus to your balance.",
  "components.organisms.Footer.logoTitle":
    "“Trend Trade” prediction exchange",
  "components.organisms.Footer.logoDescription":
    "Copying of materials is permitted only with the written consent of the platform and an active link to the source. All materials of the platform are intellectual property and are protected by copyright law.",
  "components.organisms.Footer.terms": "Terms of Use",
  "components.organisms.Footer.policy": "Support",
  "components.routes.pages.Terms.title": "Terms of Use",
  "components.organisms.Footer.navigation": "Navigation",
  "components.organisms.Footer.navigation.root": "Home",
  "components.organisms.Footer.navigation.favorites": "Favorites",
  "components.organisms.Footer.account": "Account",
  "components.organisms.Footer.account.settings": "Settings",
  "components.organisms.Footer.account.deposit": "Deposit",
  "components.organisms.Footer.account.positions": "Positions",
  "components.organisms.Footer.account.history": "History",
  "components.organisms.Footer.account.events": "My events",
  "components.organisms.Footer.account.promocodes": "Promo codes",
  "components.organisms.Footer.account.referal": "Referrals",
  "components.organisms.Footer.sites": "Our social media",
  "components.routes.pages.Favorites.btn": "Back to events",
  "components.routes.pages.Favorites.title": "Favorites",
  "components.routes.pages.Profile.title": "TREND TRADE",
  "components.organisms.BettingCard.yes": "Yes",
  "components.organisms.BettingCard.no": "No",
  "components.organisms.BettingCard.chooseBtn": "Select an outcome",
  "components.organisms.BettingCard.price": "Token price",
  "components.organisms.BettingCard.countToken": "Number of tokens",
  "components.organisms.BettingCard.commision": "Maximum amount",
  "components.organisms.BettingCard.pay": "Payout",
  "components.organisms.BettingCard.save": "Confirm",
  "components.molecules.BettingPosition.title": "Your positions",
  "components.molecules.BettingPosition.result": "Outcome",
  "components.molecules.BettingPosition.capacity": "Volume",
  "components.molecules.User.profile": "Profile",
  "components.molecules.User.settings": "Settings",
  "components.molecules.User.promocode": "Promo codes",
  "components.molecules.User.referal": "Referrals",
  "components.molecules.User.about": "About the platform",
  "components.molecules.User.logout": "Log out",
  "components.routes.pages.EventDetail.title": "Event details",
  "components.routes.pages.EventDetail.rules": "Rules",
  "components.organisms.Chart.yes": "Yes",
  "components.organisms.Chart.no": "No",
  "components.organimsms.BettingCard.input": "Enter amount",
  "components.organisms.AuthHeader.login": "Log in",
  "components.organisms.AuthHeader.register": "Sign up",
  "components.organisms.RegistrationForm.submit": "Sign up",
  "components.forms.RegistrationForm.email.placeholder": "Email",
  "components.forms.RegistrationForm.password": "Password",
  "components.organisms.RegistrationModal.title": "Sign up",
  "components.organisms.RegistrationForm.terms":
    "I accept the {link}",
  "components.organisms.RegistrationForm.link": "terms of use",
  "components.organisms.RegistrationForm.haveAccount":
    "Already have an account? {link}",
  "components.organisms.RegistrationForm.login": "Log in",
  "components.organisms.RegistrationForm.or": "or",
  "components.organisms.RegistrationForm.telegram": "Log in with Telegram",
  "components.forms.LoginForm.email.placeholder": "Email",
  "components.forms.LoginForm.password": "Password",
  "components.organisms.LoginForm.submit": "Log in",
  "components.organisms.LoginForm.haveAccount": "Don't have an account? {link}",
  "components.organisms.LoginForm.register": "Sign up",
  "components.organisms.LoginForm.or": "or",
  "components.organisms.LoginForm.telegram": "Log in with Telegram",
  "components.organisms.LoginModal.title": "Log in",
  "components.forms.DepositForm.count.placeholder": "Amount",
  "components.forms.DepositForm.count.label": "Deposit amount",
  "components.forms.DepositForm.cardNumber.placeholder": "Card number",
  "components.forms.DepositForm.cardNumber.label": "Card number",
  "components.forms.DepositForm.date.placeholder": "MM/YY",
  "components.forms.DepositForm.date.label": "Expiry date",
  "components.forms.DepositForm.cvv.placeholder": "000",
  "components.forms.DepositForm.cvv.label": "CVV",
  "components.organisms.DepositForm.save": "Save card details",
  "components.organisms.DepositForm.submit": "Top up",
  "components.organisms.DepositModal.title": "Top up balance",
  "components.forms.AddEventForm.name.placeholder": "Event title",
  "components.forms.AddEventForm.name.label": "Event title",
  "components.organisms.AddEventForm.result": "Add outcomes",
  "components.organisms.AddEventForm.resultBtn": "Add outcome",
  "components.organisms.AddEventForm.submit": "Publish",
  "components.organisms.AddEventModal.title": "Create event",
  "components.organisms.AddEventModal.detail": "Add outcome",
  "components.forms.AddEventForm.date.placeholder": "Enter a date",
  "components.forms.AddEventForm.date.label": "Event end date",
  "components.forms.AddEventForm.resultName.placeholder": "Outcome name",
  "components.forms.AddEventForm.resultName.label": "Outcome name",
  "components.organisms.AddEventForm.post": "Add",
  "components.molecules.MenuBottomBar.home": "Home",
  "components.molecules.MenuBottomBar.favorite": "Favorites",
  "components.molecules.MenuBottomBar.menu": "Menu",
  "components.molecules.MobileMenu.portfolio": "Portfolio",
  "components.molecules.MobileMenu.balance": "Balance",
  "components.organisms.BettingModal.win": "Payout:",
  "components.templates.CabinetTemplate.notifictaions": "Notifications",
  "components.organisms.PromoCodeForm.submit": "Confirm",
  "components.forms.PromoCodeForm.promocode.placeholder": "Promo code",
  "components.organisms.PromoCodeModal.title": "Enter promo code",
  "components.routes.pages.Histories.table.outputDesk": "Final outcome",
  "components.routes.modals.SignUpEmail.title": "Sign up",
  "components.routes.modals.SingInEmail.title": "Log in",
  "components.atoms.Loader.text": "Loading",
  "components.forms.VerifyCodeForm.title": "Enter the code",
  "components.forms.VerifyCodeForm.code.placeholder":
    "Enter the code from your email",
  "components.organisms.VerifyCodeForm.submit": "Confirm",
  "components.forms.VerifyCodeForm.resend": "Resend code",
  "components.routes.modals.VerifyCode.title": "Confirmation code",
  "components.routes.modals.SendResetCode.title": "Confirmation code",
  "components.organisms.Footer.account.login": "Log in",
  "components.organisms.Footer.account.register": "Sign up",
  "components.organisms.Footer.account.notifications": "Notifications",
  "components.atoms.Pagination.text": "of ",
  "components.atoms.PageItemCount.text": "Rows:",
  "components.organisms.NotificationDropdown.noData": "List is empty",
  "components.routes.pages.Profile.noData": "List is empty",
  "components.forms.AddEventForm.description.placeholder":
    "Event description",
  "components.forms.AddEventForm.description.label": "Event description",
  "components.organisms.AddEventModal.editTitle": "Edit outcome",
  "components.organisms.AddEventForm.save": "Save",
  "components.molecules.InfoMessage.title": "Your event is under review.",
  "components.molecules.InfoMessage.description":
    "We will send you a notification as soon as it is reviewed and published.",
  "components.organisms.AddEmailModal.title": "Enter your email and password",
  "components.forms.AddEmailForm.email.placeholder": "Enter your email",
  "components.organisms.AddEmailForm.submit": "Confirm",
  "components.routes.pages.Profile.showMore": "Show more",
  "components.organisms.ModerationEvenetModal.title": "Event under review",
  "components.organisms.ModerationEvenetModal.description":
    "This event is unavailable — you will be able to view it once it is approved",
  "components.organisms.BettingResultModal.success": "Success",
  "components.organisms.BettingResultModal.error": "Error",
  "components.organisms.BettingResultModal.errorDescription":
    "Please try again later",
  "components.organisms.LoginForm.forgetPassword": "Forgot your password? {link} ",
  "components.organisms.LoginForm.forgetPassword.link": "Reset",
  "components.forms.ForgetPasswordForm.email.placeholder": "Email",
  "components.organisms.ForgetPasswordForm.submit": "Confirm",
  "components.routes.modals.ForgetPassword.title": "Password recovery",
  "components.routes.modals.ResetPassword.title": "Create a new password",
  "components.forms.ResetPasswordForm.title": "Create a new password",
  "components.forms.ResetPasswordForm.password": "Password",
  "components.forms.ResetPasswordForm.confirmPassword": "Confirm password",
  "components.forms.ResetPasswordForm.submit": "Save",
  "components.forms.EditUserDataForm.title": "Update details",
  "components.forms.EditUserDataForm.btn": "Save",
  "components.organisms.Chart.stoppedDedline": "Trading paused",
  "components.organisms.Chart.expiredDedline": "Event has ended",
  "components.organisms.AuthHeader.searchTablet": "Search",
  "components.routes.pages.Favorites.select": "Cards:",
  "components.organisms.OnboardingModal.next": "Next",
  "components.organisms.OnboardingModal.finish": "Finish",
  "components.routes.modals.Deposit.title": "Deposit",
  "components.routes.modals.DepositAddress.title": "Deposit address",
  "components.routes.modals.Withdraw.title": "Withdrawal",
  "components.routes.modals.WithdrawForm.title": "Withdrawal form",
  "components.routes.modals.CryptoList.title": "Select cryptocurrency",
};
